import { render, staticRenderFns } from "./MarketProductCardSkeleton.vue?vue&type=template&id=3174fd6d&"
import script from "./MarketProductCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./MarketProductCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports